import { useEffect, useMemo } from 'react';

import { usePositionsQuery } from '../store/tradingApiSlice';
import { buildPositionSuggestions } from '../components/ManualOrderEntry/positionSuggestions';

/** Keep the manual-order contract suggestions synchronized with account positions. */
export const useManualOrderPositionSuggestions = () => {
  const { data: positionsResponse, refetch } = usePositionsQuery();

  useEffect(() => {
    const refreshPositions = () => { void refetch(); };
    window.addEventListener('trading-data-refresh', refreshPositions);
    return () => window.removeEventListener('trading-data-refresh', refreshPositions);
  }, [refetch]);

  return useMemo(
    () => buildPositionSuggestions(
      positionsResponse?.data?.positions || [],
      Boolean(positionsResponse?.data?.stale),
      positionsResponse?.timestamp,
    ),
    [positionsResponse],
  );
};
